import PosUtils from '@/modules/common/utils'

const CONSULT_BTN_ID = 'consult-btn'

const consultBtnPlugin = (Vue, options) => {

  const audioFn = {
    init(config,consultDialog) {
      console.log()
      let style = PosUtils.getPositionStyle(config)
      let domText = `
        <img id="${CONSULT_BTN_ID}" src="${config.src}" style="position:fixed;z-index:100;width:${style.width};height:${style.height};left:${style.left};top:${style.top};" class="consult-btn-class"/>
      `

      let qrcodeRes = document.body.insertAdjacentHTML('beforeEnd',domText)
      $(`#${CONSULT_BTN_ID}`).off().click(() => {
        console.log(11)
        consultDialog.show()
      })
      return qrcodeRes
    },
    // 进入游戏后 隐藏播放器
    // 退出游戏后 恢复播放器
    hide() {
      if (!$vm) return false
      $vm.isHide = true
      window.appAudio && window.appAudio.pause()
      // 记录当前状态
      $vm.lastStatus = $vm.isPlaying
    },
    show() {
      if (!$vm) return false
      if (!$vm.isHide) return false
      $vm.isHide = false

      if ($vm.lastStatus) {
        window.appAudio && window.appAudio.play()
      }

      $vm.lastStatus = null
    }
  }
  Vue.prototype.$consultBtn = audioFn
}

export default consultBtnPlugin